<!--The content below is only a placeholder and can be replaced.-->
<app-loader></app-loader>
<router-outlet></router-outlet>
